<template>
  <div id="about">
    <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>
    <div class="main">
      <div class="headTit">
        帮助中心
        <span @click="Back()" class="backBtn">返回 ></span>
      </div>
      <div class="helpDetail">
        <div class="title">{{data.title}}</div>
        <div v-html="data.text" class="Detail">{{data.text}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import mainHeader from '../../view/header'
export default {
  components: {
    mainHeader
  },
  data () {
    return {
      tabFlag: 0,
      data: {
        create_time: '2018-09-17 13:19:34',
        creator: '1',
        id: 3,
        text: '',
        title: '',
        type: '1'
      }
    }
  },
  methods: {
    logoutClick: function () {
      // this.$router.push({path: 'home'})
    },
    getDetail () {
      let id = this.$route.query.id
      this.utils.GET(this.companyUrl + '/help/helpDetail?id=' + id, res => {
        this.data.title = res.data.title
        this.data.text = res.data.text
      })
    },
    // findDetail (id) {
    //   this.$router.push({
    //     path: '/helpDetail',
    //     query: {
    //       id: id
    //     }
    //   })
    // },
    Back () {
      window.history.go(-1)
    }
  },
  mounted () {
    this.getDetail()
    window.scroll(0, 0)
  }
}
</script>

<style lang="scss" scoped>
body {
  height: 100%;
  width: 100%;
  background: #f4f4f4;
}
.mainHeader {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 500;
}
.main {
  margin-top: 55px;
  display: block;
  width: 100%;
  box-sizing: border-box;
  .headTit {
    background: #ffffff;
    padding: 0 14px 0 14px;
    line-height: 50px;
    color: #000000;
    font-size: 15px;
    font-weight: bold;
    border-bottom: 10px solid #f4f4f4;
    .backBtn {
      font-size: 13px;
      color: #999999;
      float: right;
      font-weight: normal;
    }
  }
  .helpDetail {
    padding: 12.5px 14px 0 14px;
    .title {
      color: #000000;
      font-size: 15px;
      font-weight: bolder;
      margin-bottom: 38px;
    }
    .Detail {
      display: inline-block;
      >>> p {
        display: inline-block;
        margin-bottom: 20px;
      }
      >>> img {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/helpCenter/helpDetail.vue